/**
 * Registry sprite charforge: gộp mọi hàm vẽ 48×48 theo ID manifest.
 *
 * Mỗi hàm vẽ thô nhận (raster, rng); registry bọc lại để tự tạo RNG đã seed
 * từ ID (bamId) — người dùng chỉ cần gọi dangKy(id)(raster), luôn deterministic.
 *
 * Hợp đồng: keys(DANG_KY_SPRITE) PHẢI khớp 1–1 với id trong
 * src/data/manifest.json (tools/validate-manifest.ts kiểm tra).
 */
import { bamId, mulberry32, type Raster, type VeSprite } from '../raster.js';
import { VE_BOI_CANH } from './boi-canh.js';
import { VE_CON_NGUOI } from './con-nguoi.js';
import { VE_MON } from './mon.js';

type VeTho = (r: Raster, rng: () => number) => void;

const VE_THO: Record<string, VeTho> = {
  ...VE_MON,
  ...VE_CON_NGUOI,
  ...VE_BOI_CANH,
};

/** Vẽ sprite theo ID lên raster (RNG tự seed từ ID — deterministic). */
export function veSprite(id: string, r: Raster): void {
  const ve = VE_THO[id];
  if (!ve) {
    throw new Error(`Không có hàm vẽ charforge cho asset "${id}".`);
  }
  ve(r, mulberry32(bamId(id)));
}

/** Registry đầy đủ: ID manifest → hàm vẽ (raster) => void. */
export const DANG_KY_SPRITE: Record<string, VeSprite> = Object.fromEntries(
  Object.keys(VE_THO).map((id) => [id, (r: Raster) => veSprite(id, r)]),
);

/** Danh sách ID sprite đã đăng ký (sắp xếp ổn định). */
export function danhSachIdSprite(): string[] {
  return Object.keys(DANG_KY_SPRITE).sort();
}
